import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { reportsRef, serverTimestamp } from '../../firebase/collections';
import { ToastContext } from '../../contextStore/ToastContext';
import { canProceed, RATE_LIMITS } from '../../utils/rateLimit';
import './ReportAd.css';

function ReportAd({ productId, reporterId, onClose }) {
  const { t } = useTranslation();
  const { addToast } = useContext(ToastContext);
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!reason || !reporterId || !productId) return;
    if (!canProceed('report', RATE_LIMITS.REPORT_MS)) {
      addToast(t('report.waitBeforeReport'), 'info');
      return;
    }
    setSubmitting(true);
    const reportId = `${reporterId}_${productId}`;
    reportsRef()
      .doc(reportId)
      .set({
        productId,
        reporterId,
        reason,
        description: description.trim() || null,
        status: 'pending',
        createdAt: serverTimestamp(),
      })
      .then(() => {
        addToast(t('report.reportSubmitted'), 'success');
        onClose();
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="reportAdOverlay" onClick={onClose}>
      <div className="reportAdModal" onClick={(e) => e.stopPropagation()}>
        <h3>{t('report.reportAd')}</h3>
        <form onSubmit={handleSubmit}>
          <label>{t('report.reason')}</label>
          <select
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="reportAdSelect"
            required
          >
            <option value="">{t('report.selectReason')}</option>
            <option value="Spam">{t('report.spam')}</option>
            <option value="Inappropriate content">{t('report.inappropriateContent')}</option>
            <option value="Fraud or scam">{t('report.fraudOrScam')}</option>
            <option value="Prohibited item">{t('report.prohibitedItem')}</option>
            <option value="Other">{t('report.other')}</option>
          </select>
          <label>{t('report.additionalDetails')}</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="reportAdTextarea"
            rows={3}
            placeholder={t('report.describeIssue')}
          />
          <div className="reportAdActions">
            <button
              type="button"
              onClick={onClose}
              className="reportAdBtn cancel"
            >
              {t('common.cancel')}
            </button>
            <button
              type="submit"
              className="reportAdBtn submit"
              disabled={submitting}
            >
              {submitting ? t('report.submitting') : t('report.submitReport')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ReportAd;
